export function globalSearch() {
    const $html = this.$html;
    const $header = this.$header;
    const $globalSearchContainer = $header.find(".global-search");
    const $globalSearchToggler = $header.find(".global-site-search-toggler");
    const $popupsContainer = this.$popupsContainer;
    const $globalSearchCloseButton = $(".global-search-close-button");

    $globalSearchToggler.on(this.pushEvent, function () {
        if ($html.hasClass("global-search-is-active")) {
            $html.removeClass("global-search-is-active");
        } else {
            $html.addClass("global-search-is-active");
            setTimeout(function () {
                $(".global-search input").focus();
            }, 500);

        }
    });

    $globalSearchCloseButton.on(this.pushEvent, function () {
        if ($html.hasClass("global-search-is-active")) {
            $html.removeClass("global-search-is-active");
        } else {
            $html.addClass("global-search-is-active");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/global-search.js